export const { log } = console
